import React, { Component } from 'react'
import { injectStripe } from 'react-stripe-elements'
import { connect } from 'react-redux'
import moment from 'moment'
import { formatPrice } from 'Helpers/format-helper'
import Button from 'Ui/Button'
import { offersAnnualDiscount } from './SubscriptionPage'


class SpinnerButton extends Component {
  render() {
    return (
      <label className={`primary small-height flex justify-center align-center`}>
        <img src="/assets/images/spinner.gif" alt="Veuillez patienter" />
      </label>
    )
  }
}

class ChangeIntervalFormWithoutStripe extends Component {
  render() {
    const { subscription, subData, onClickChangeInterval, prorationsLoading, changeOfferLoading, stripe } = this.props
    if (!subscription) return ''
    const { monthlyPrice, interval, interval_count } = subData

    let monthlyButton = <div className="px-[42px] py-[9px] border-1 border-black rounded md:inline-block">Souscrit</div>

    // users are allowed to switch back to monthly only during the last month of their subscription
    if (interval !== 'month') {
      if (moment.unix(subscription.current_period_end).diff(moment(), 'days', true) > 30
        || subscription.status === 'trialing'
      ) {
        monthlyButton = null
      } else {
        monthlyButton = (
          <Button
            label={
              prorationsLoading || changeOfferLoading ? (
                <div className="flex justify-center align-center">
                  <img height="15px" src="/assets/images/spinner.gif" alt="Veuillez patienter" />
                </div>
              ) : (
                'Souscrire'
              )
            }
            onClick={() => onClickChangeInterval(stripe, 'month', 1)}
            secondaryClass="primary small-height"
          />
        )
      }
    }

    const yearsOffers = [1, 2, 3]
    const annualOffer = offersAnnualDiscount.find(offer => offer.offerVersion === 'v2')

    return (
      <div className="interval-offers">
        {monthlyButton && (
          <div className="interval-offers-line">
            <div className="col1">Mensuelle</div>
            <div className="col2">{formatPrice(monthlyPrice / 100, true)} HT/mois</div>
            <div className="col3">{monthlyButton}</div>
          </div>
        )}
        <div className="interval-offers-year-block">
          <div className="interval-offers-year-header">Recommandé</div>
          {yearsOffers.map((index) => {
            if (interval === 'year' && interval_count > index) return null
            const isCurrentlySubscribed = interval === 'year' && interval_count === index

            let title = '1 an'
            if (index === 2) title = '2 ans'
            if (index === 3) title = '3 ans'

            const offerRate = annualOffer.discountRates[index]
            const offerText = annualOffer.discountTexts[index]

            const newMonthlyPrice = monthlyPrice * (1 - offerRate / 100) / 100
            const newTotalPrice = newMonthlyPrice * 12 * index

            let button = null
            if (isCurrentlySubscribed) {
              button = <div className="px-[42px] py-[9px] border-1 border-black rounded md:inline-block">Souscrit</div>
            } else if (interval === 'month' || interval_count < index) {
              button = (
                <Button
                  disabled={changeOfferLoading || prorationsLoading}
                  label={changeOfferLoading || prorationsLoading ? <SpinnerButton /> : 'Souscrire'}
                  onClick={() => onClickChangeInterval(stripe, 'year', index)}
                  secondaryClass="primary small-height"
                />
              )
            }

            return (
              <div key={index} className="interval-offers-line">
                <div className="col1">
                  <div className="title">{title}</div>
                  <div className="price-small">
                    {!isCurrentlySubscribed && (
                      <>{offerText}<sup>*</sup></>
                    )}
                  </div>
                </div>
                <div className="col2">
                  {!isCurrentlySubscribed && (
                    <>
                      <div className="">{formatPrice(newTotalPrice, true)} HT</div>
                      <div className="price-small">
                        (soit {formatPrice(newMonthlyPrice, true)} HT/mois)
                      </div>
                    </>
                  )}
                </div>
                <div className="col3">
                  {button}
                </div>
              </div>
            )
          })}
          {interval_count !== 3 && (
            <div className="interval-offers-line">
              <div className="interval-offers-year-explanation">
                <div className=""><sup>*</sup>Réduction appliquée sur le premier paiement</div>
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }
}

const ChangeIntervalForm = connect()(injectStripe(ChangeIntervalFormWithoutStripe))

export default ChangeIntervalForm